<template>
  <v-dialog :value="isOpen" persistent scrollable max-width="360px">
    <v-card>
      <v-card-title>
        <h3>
          表示するキャンペーンの期間を選択してください
        </h3>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-checkbox
          :key="campaignBudget.campaignBudgetId"
          v-for="campaignBudget in filteredCampaignBudgets"
          :input-value="isSelected(campaignBudget.campaignBudgetId)"
          @change="onClickCheckBox(campaignBudget.campaignBudgetId, $event)"
          hide-details
          messages="none"
        >
          <template v-slot:label>
            <AppPeriod
              :start="campaignBudget.startTime"
              :end="campaignBudget.endTime"
            />
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click.native="cancel">
          閉じる
        </v-btn>
        <v-btn @click.native="close" color="primary">
          変更する
        </v-btn>
      </v-card-actions>
      <v-divider />
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'MainTableCampaignRowBudgetSelector',
  props: {
    insertionOrderId: {
      type: Number,
      required: true,
    },
    campaignId: {
      type: Number,
      required: true,
    },
    campaignBudgets: {
      type: Array,
      required: true,
    },
    selectedCampaignBudgetIds: {
      type: Array,
      required: true,
    },
    // モーダルの開閉
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tmpSelectedCampaignBudgetIds: this.selectedCampaignBudgetIds,
    }
  },
  computed: {
    filteredCampaignBudgets() {
      const filteredCampaignBudgets = this.campaignBudgets.filter(budget =>
        dayjs().isAfter(dayjs(budget.startTime).endOf('minute')),
      )
      return _sortBy(filteredCampaignBudgets, 'startTime')
    },
  },
  watch: {
    selectedCampaignBudgetIds() {
      this.tmpSelectedCampaignBudgetIds = this.selectedCampaignBudgetIds
    },
  },
  methods: {
    onClickCheckBox(campaignBudgetId, isChecked) {
      if (isChecked) {
        this.addCampaignBudgetId(campaignBudgetId)
      } else {
        this.removeCampaignBudgetId(campaignBudgetId)
      }
    },
    addCampaignBudgetId(campaignBudgetId) {
      this.tmpSelectedCampaignBudgetIds = [
        ...this.tmpSelectedCampaignBudgetIds,
        campaignBudgetId,
      ]
    },
    removeCampaignBudgetId(campaignBudgetId) {
      this.tmpSelectedCampaignBudgetIds = this.tmpSelectedCampaignBudgetIds.filter(
        cbId => cbId !== campaignBudgetId,
      )
    },
    isSelected(campaignBudgetId) {
      return this.tmpSelectedCampaignBudgetIds.includes(campaignBudgetId)
    },
    close() {
      this.$emit('close', {
        insertionOrderId: this.insertionOrderId,
        campaignId: this.campaignId,
        campaignBudgetIds: this.tmpSelectedCampaignBudgetIds,
      })
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss">
.calender {
  width: 60px;
  margin: 0 auto;
  border-radius: 5px;
  /*padding: 10px 0;*/
  display: flex;
  justify-content: center;
}
.v-input {
  margin-top: 0;
}

.v-messages {
  display: none;
}
</style>
